import { EventTableInterval } from '../types.ts';

export const tableIntervalValueToKey: Record<string, keyof typeof EventTableInterval> =
  Object.entries(EventTableInterval).reduce(
    (acc, [key, value]) => {
      acc[value] = key as keyof typeof EventTableInterval;
      return acc;
    },
    {} as Record<string, keyof typeof EventTableInterval>
  );
